export const DEALER_LICENCE = 'dealer-licence';
export const DEALERS_CONTACT_PERSON_DETAILS = 'dealers-contact-person-details';
export const DEALERS_LICENCE_MAILING_ADDRESS = 'dealers-licence-mailing-address';
export const OTHER_DETAILS = 'other-details';
export const EQUIPMENT_INFORMATION = 'equipment-information';
export const TECHNICAL_DATA_INFORMATION = 'technical-data-information';
export const EQUIPMENT_TECHNICAL_DATA_LINE = 'equipment-technical-data-line';
export const CANCEL_LICENCE_INFORMATION = 'cancel-licence-information';
export const RENEW_LICENCE_INFORMATION = 'renew-licence-information';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const AMEND_COFC_APPLICATION = [
    {
        sectionID: DEALER_LICENCE,
        sectionName: '',
        fieldList: [
            {
                id: 'dealer-licence-no',
                label: 'Dealer Licence No.',
                type: 'text'
            },
            {
                id: 'dealer-licence-company-name',
                label: "Dealer's Licence Company Name",
                type: 'text'
            },
            {
                id: 'scheme-type',
                label: 'Scheme Type',
                type: 'text'
            }
        ]
    },
    {
        sectionID: DEALERS_CONTACT_PERSON_DETAILS,
        sectionName: "Dealer's Contact Person Details",
        fieldList: [
            {
                id: 'same-as-applicant-particulars',
                label: 'Same as Applicant Particulars',
                type: 'text',
                span: 12
            },
            {
                id: 'name',
                label: 'Name',
                type: 'text'
            },
            {
                id: 'designation',
                label: 'Designation',
                type: 'text'
            },
            {
                id: 'email',
                label: 'Email',
                type: 'text'
            },
            {
                id: 'office-tel-number',
                label: 'Office Tel Number',
                type: 'text'
            },
            {
                id: 'mobile-number',
                label: 'Mobile Number',
                type: 'text'
            },
            {
                id: 'fax-number',
                label: 'Fax Number',
                type: 'text'
            }
        ]
    },
    {
        sectionID: DEALERS_LICENCE_MAILING_ADDRESS,
        sectionName: "Dealer's Licence Mailing Address",
        fieldList: [
            {
                id: 'same-as-applicant-particulars',
                label: 'Same as Applicant Particulars',
                type: 'text',
                span: 12
            },
            {
                id: 'building-name',
                label: 'Building Name',
                type: 'text'
            },
            {
                id: 'postal-code',
                label: 'Postal Code',
                type: 'text'
            },
            {
                id: 'street-name',
                label: 'Street Name',
                type: 'text'
            },
            {
                id: 'block-house-no',
                label: 'Block/House No.',
                type: 'text'
            },
            {
                id: 'floor-level-optional',
                label: 'Floor/Level (Optional)',
                type: 'text'
            },
            {
                id: 'unit-optional',
                label: 'Unit (Optional)',
                type: 'text'
            }
        ]
    },
    {
        sectionID: OTHER_DETAILS,
        sectionName: 'Other Details',
        fieldList: [
            {
                id: 'public-contact-no',
                label: 'Public Contact No.',
                type: 'text',
                span: 12
            },
            {
                id: 'remarks',
                label: 'Remarks',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: EQUIPMENT_INFORMATION,
        sectionName: 'Equipment Information',
        fieldList: [
            {
                id: 'cofc-equipment-type',
                label: 'Equipment Type for Confirmation of Confirmity (COFC)(Equipment Type)',
                type: 'text',
                span: 12
            },
            {
                id: 'mandatory-imda-spec-no-desc',
                label: 'Mandatory IMDA Spec No./Desc.',
                type: 'text',
                span: 12
            },
            {
                id: 'equipment-description',
                label: 'Equipment Description',
                type: 'text'
            },
            {
                id: 'brand-trade-name',
                label: 'Brand/Trade Name',
                type: 'text'
            },
            {
                id: 'model-no',
                label: 'Model No',
                type: 'text'
            },
            {
                id: 'marketing-name',
                label: 'Marketing Name (Optional)',
                type: 'text'
            },
            {
                id: 'manufacturer-name',
                label: 'Manufacturer',
                type: 'text'
            },
            {
                id: 'manufacturer-country',
                label: 'Manufacturer Country',
                type: 'text'
            },
            {
                id: 'country-of-origin',
                label: 'Country of Origin/Import Country',
                type: 'text'
            },
            {
                id: 'network-connection',
                label: 'Network Connection',
                type: 'text'
            }
        ]
    },
    {
        sectionID: TECHNICAL_DATA_INFORMATION,
        sectionName: 'Technical Data Information',
        fieldList: [
            {
                id: 'test-lab-name',
                label: 'Test Lab Name',
                type: 'text'
            },
            {
                id: 'test-report-no',
                label: 'Test Report No. (Optional)',
                type: 'text'
            },
            {
                id: 'country-of-lab',
                label: 'Country of Lab',
                type: 'text',
                span: 12
            },
            {
                id: 'applied-for',
                label: 'Applied For',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: EQUIPMENT_TECHNICAL_DATA_LINE,
        sectionName: 'Equipment Technical Data - Line',
        fieldList: [
            {
                id: 'auto-dial-feature',
                label: 'Auto-Dial Feature (Optional)',
                type: 'text'
            },
            {
                id: 'protocol',
                label: 'Protocol (Optional)',
                type: 'text'
            },
            {
                id: 'type-of-customer-interface',
                label: 'Type of Customer Interface (Optional)',
                type: 'text'
            },
            {
                id: 'line-ports',
                label: 'Line Ports (Optional)',
                type: 'text'
            },
            {
                id: 'list-of-customised-terminals-used',
                label: 'List of Customised Terminals Used (Optional)',
                type: 'text',
                span: 12
            },
            {
                id: 'list-of-network-interface-cards',
                label: 'List of Network Interface Cards (Optional)',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: CANCEL_LICENCE_INFORMATION,
        sectionName: 'Licence Information',
        fieldList: [
            {
                id: 'scheme-type',
                label: 'Scheme Type',
                type: 'text',
                span: 12
            },
            {
                id: 'dealer-licence-no',
                label: 'Dealer Licence No.',
                type: 'text',
                span: 12
            },
            {
                id: 'equipment-type',
                label: 'Equipment Type',
                type: 'text',
                span: 12
            },
            {
                id: 'imda-spec-no-desc',
                label: 'IMDA Spec. No/Desc',
                type: 'text',
                span: 12
            },
            {
                id: 'equipment-description',
                label: 'Equipment Description',
                type: 'text',
                span: 12
            },
            {
                id: 'brand-trade-name',
                label: 'Brand/Trade Name',
                type: 'text',
                span: 12
            },
            {
                id: 'model-no',
                label: 'Model No',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            hidden: true
        }
    },
    {
        sectionID: RENEW_LICENCE_INFORMATION,
        sectionName: 'Licence Information',
        fieldList: [
            {
                id: 'scheme-type',
                label: 'Scheme Type',
                type: 'text',
                span: 12
            },
            {
                id: 'dealer-licence-no',
                label: 'Dealer Licence No.',
                type: 'text',
                span: 12
            },
            {
                id: 'equipment-type',
                label: 'Equipment Type (Optional)',
                type: 'text',
                span: 12
            },
            {
                id: 'imda-spec-no-desc',
                label: 'IMDA Spec. No/Desc',
                type: 'text',
                span: 12
            },
            {
                id: 'equipment-description',
                label: 'Equipment Description',
                type: 'text',
                span: 12
            },
            {
                id: 'brand-trade-name',
                label: 'Brand/Trade Name',
                type: 'text',
                span: 12
            },
            {
                id: 'model-no',
                label: 'Model No',
                type: 'text',
                span: 12
            }
        ],
        rule: {
            hidden: true
        }
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
